/* Better Speed theme — theme.js
   Drawers + cart wired to Shopify Cart AJAX + Section Rendering API.
   Every cart mutation asks Shopify to re-render the cart-drawer section,
   so item rows, subtotal, and the empty state are always server-accurate. */

(function () {
  function q(sel) { return document.querySelector(sel); }

  function showScrim(on) {
    var scrim = q('[data-scrim]');
    scrim && scrim.classList.toggle('show', on);
    document.body.style.overflow = on ? 'hidden' : '';
  }
  function closeAll() {
    var d = q('[data-drawer]'); d && d.classList.remove('open');
    var c = q('[data-cart-panel]'); c && c.classList.remove('open');
    var s = q('[data-search-modal]'); if (s) s.hidden = true;
    showScrim(false);
  }
  function openDrawer() { q('[data-drawer]').classList.add('open'); showScrim(true); }
  function openCart() { q('[data-cart-panel]').classList.add('open'); showScrim(true); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-drawer]')) openDrawer();
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-open-search]')) {
      e.preventDefault();
      var s = q('[data-search-modal]');
      if (s) { s.hidden = false; showScrim(true); var inp = s.querySelector('[data-search-input]'); inp && inp.focus(); }
    }
    if (e.target.closest('[data-close-drawers]')) closeAll();
    if (e.target === q('[data-scrim]')) closeAll();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- collection: inline filter panel + grid columns ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-toggle-filters]')) {
      var p = q('[data-filter-panel]');
      p && p.classList.toggle('open');
    }
    var colBtn = e.target.closest('[data-cols]');
    if (colBtn) {
      var grid = q('[data-pgrid]');
      if (grid) {
        grid.classList.toggle('cols2', colBtn.dataset.cols === '2');
        document.querySelectorAll('[data-cols]').forEach(function (b) { b.classList.toggle('on', b === colBtn); });
      }
    }
  });

  /* ---------- cart section re-render ---------- */
  function swapCartSection(sectionsHtml, keepOpen) {
    var html = sectionsHtml && sectionsHtml['cart-drawer'];
    if (!html) return;
    var wrap = document.getElementById('shopify-section-cart-drawer');
    if (!wrap) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('.cartpanel');
    var current = wrap.querySelector('.cartpanel');
    if (fresh && current) {
      /* copy the fresh content INTO the existing panel instead of replacing
         the node — the painted panel keeps its committed off-screen position,
         so the slide-in transition always plays (a freshly inserted node can
         be painted already-open, skipping the transition entirely) */
      current.innerHTML = fresh.innerHTML;
      if (!keepOpen) current.classList.remove('open');
    }
    /* update header badge from the fresh title "(n)" */
    var title = fresh && fresh.querySelector('[data-cart-title]');
    if (title) {
      var m = title.textContent.match(/\((\d+)\)/);
      if (m) document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = m[1]; });
    }
  }

    async function changeLine(line, quantity) {
    var res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer' })
    });
    if (res.ok) {
      var data = await res.json();
      swapCartSection(data.sections, true);
    }
  }

  /* ---------- cart: change size in place (remove old line, add the new variant) ---------- */
  async function changeSize(line, newVariantId, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    });
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: newVariantId, quantity: quantity }], sections: 'cart-drawer' })
    });
    if (res.ok) {
      var data = await res.json();
      swapCartSection(data.sections, true);
    }
  }

  document.addEventListener('click', function (e) {
    var item = e.target.closest('.cartitem');
    if (!item) return;
    var line = parseInt(item.dataset.line, 10);
    var current = parseInt(item.querySelector('.qnum').textContent, 10);
    if (e.target.closest('[data-qty-plus]')) changeLine(line, current + 1);
    if (e.target.closest('[data-qty-minus]')) changeLine(line, Math.max(1, current - 1));
    if (e.target.closest('[data-remove]')) { e.preventDefault(); changeLine(line, 0); }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-size-select]');
    if (!sel) return;
    var item = sel.closest('.cartitem');
    if (!item) return;
    var line = parseInt(item.dataset.line, 10);
    var qty = parseInt(item.querySelector('.qnum').textContent, 10);
    var newVariantId = parseInt(sel.value, 10);
    sel.disabled = true;
    changeSize(line, newVariantId, qty);
  });

  /* ---------- add to cart: open drawer instead of redirect ---------- */
  document.addEventListener('submit', async function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    var res = await fetch('/cart/add.js', { method: 'POST', body: fd });
    if (res.ok) {
      var data = await res.json();
      swapCartSection(data.sections, false);
      /* commit the fresh panel's off-screen position with a forced reflow,
         otherwise adding 'open' in the same tick paints it already-open
         and the slide-in transition never plays */
      var panel = q('[data-cart-panel]');
      if (panel) void panel.offsetWidth;
      openCart();
    }
  });

  /* ---------- product page: variant selection ---------- */
  (function () {
    var variants = window.__productVariants;
    if (!variants) return;
    var selected = {};

    function currentOptions() {
      document.querySelectorAll('.sw.on,[data-option-pos].szbtn.on').forEach(function (b) {
        selected[b.dataset.optionPos] = b.dataset.value;
      });
    }
    function findVariant() {
      return variants.find(function (v) {
        return Object.keys(selected).every(function (pos) {
          return v['option' + pos] === selected[pos];
        });
      });
    }
    function money(cents) { return '$' + (cents / 100).toFixed(2); }

    /* ---------- slide-push image swap (Slide Push, 300ms) ----------
       Old image slides out LEFT while the new one pushes in from the
       RIGHT, in tandem. #MainProductImage stays the source of truth
       (the lightbox reads it): when the slide lands, the main image
       adopts the new src and both layers reset in the same frame —
       identical pixels, so the snap is invisible. Rapid clicks queue
       the latest target; transitionend + safety timeout = never stuck.
       Tune the speed via SLIDE_MS below. */
    var SLIDE_MS = 300;
    var slideBusy = false, slidePending = null, slideLast = '';
    var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function swapImage(url) {
      var a = document.getElementById('MainProductImage');
      if (!a) return;
      var b = document.getElementById('MainProductImageB');
      if (!b || REDUCED) { a.src = url; return; }
      if (url === slideLast && !slideBusy) return;
      if (slideBusy) { slidePending = url; return; }
      slideBusy = true; slideLast = url;
      var sign = window.__imageSwipeDir === 'prev' ? -1 : 1;
      window.__imageSwipeDir = null;
      b.src = url;
      var started = false;
      function start() {
        if (started) return; started = true;
        a.style.transition = 'none'; b.style.transition = 'none';
        a.style.transform = 'translateX(0)';
        b.style.transform = 'translateX(' + (115 * sign) + '%)';
        b.style.opacity = '1';
        void b.offsetWidth;
        a.style.transition = 'transform ' + SLIDE_MS + 'ms ease';
        b.style.transition = 'transform ' + SLIDE_MS + 'ms ease';
        requestAnimationFrame(function () {
          a.style.transform = 'translateX(' + (-115 * sign) + '%)';
          b.style.transform = 'translateX(0)';
          var done = false;
          function finish() {
            if (done) return; done = true;
            a.style.transition = 'none'; b.style.transition = 'none';
            a.src = b.src;
            a.style.transform = '';
            b.style.transform = 'translateX(' + (115 * sign) + '%)';
            b.style.opacity = '0';
            void b.offsetWidth;
            a.style.transition = ''; b.style.transition = '';
            slideBusy = false;
            if (slidePending) { var p = slidePending; slidePending = null; swapImage(p); }
          }
          b.addEventListener('transitionend', function h(e) {
            if (e.target === b) { b.removeEventListener('transitionend', h); finish(); }
          });
          setTimeout(finish, SLIDE_MS + 400);
        });
      }
      if (b.complete && b.naturalWidth) start();
      else { b.onload = start; setTimeout(start, 300); }
    }

    function markAvailability() {
      document.querySelectorAll('.sw[data-option-pos], .szbtn[data-option-pos]').forEach(function (btn) {
        var test = {};
        Object.keys(selected).forEach(function (k) { test[k] = selected[k]; });
        test[btn.dataset.optionPos] = btn.dataset.value;
        var match = variants.find(function (v) {
          return Object.keys(test).every(function (pos) { return v['option' + pos] === test[pos]; });
        });
        btn.classList.toggle('unavail', !(match && match.available));
      });
    }

    function apply(variant) {
      var atc0 = document.querySelector('.atc');
      if (!variant) {
        /* selected combination does not exist as a variant */
        var idInput0 = document.querySelector('[data-variant-id]');
        if (idInput0) idInput0.value = '';
        if (atc0) { atc0.disabled = true; atc0.textContent = 'Unavailable'; }
        return;
      }
      var idInput = document.querySelector('[data-variant-id]');
      if (idInput) idInput.value = variant.id;
      var sized = window.__variantImages && window.__variantImages[variant.id];
      var imgUrl = sized || (variant.featured_image && variant.featured_image.src) || '';
      if (imgUrl) swapImage(imgUrl);
      var price = document.querySelector('[data-price]');
      if (price) price.textContent = money(variant.price);
      var cmp = document.querySelector('[data-compare-price]');
      var badge = document.querySelector('[data-sale-badge]');
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (cmp) { cmp.style.display = onSale ? '' : 'none'; if (onSale) cmp.textContent = money(variant.compare_at_price); }
      if (badge) badge.style.display = onSale ? '' : 'none';
      var atc = document.querySelector('.atc');
      if (atc) {
        atc.disabled = !variant.available;
        atc.textContent = variant.available ? (atc.dataset.label || 'Add to Cart') : 'Sold out';
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.sw[data-option-pos], .szbtn[data-option-pos]');
      if (!btn) return;
      var pos = btn.dataset.optionPos;
      document.querySelectorAll('[data-option-pos="' + pos + '"]').forEach(function (b) { b.classList.toggle('on', b === btn); });
      var colorLabel = document.querySelector('[data-selected-color]');
      var sizeLabel = document.querySelector('[data-selected-size]');
      if (btn.classList.contains('sw') && colorLabel) colorLabel.textContent = btn.dataset.value;
      if (btn.classList.contains('szbtn') && sizeLabel) sizeLabel.textContent = btn.dataset.value;
      currentOptions();
      apply(findVariant());
      markAvailability();
    });
    currentOptions();
    markAvailability();
    var initVariant = findVariant();
    if (initVariant) {
      var initUrl = (window.__variantImages && window.__variantImages[initVariant.id]) || (initVariant.featured_image && initVariant.featured_image.src) || '';
      if (initUrl) slideLast = initUrl;
    }
  
  /* ---------- predictive search ---------- */
  (function () {
    var cfg = window.__search;
    if (!cfg) return;
    var input = q('[data-search-input]');
    if (!input) return;
    var defaults = q('[data-search-default]');
    var results = q('[data-search-results]');
    var grid = q('[data-search-results-grid]');
    var empty = q('[data-search-empty]');
    var timer;

    function card(p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
      var price = p.price ? ('$' + p.price) : '';
      return '<a class="product" href="' + p.url + '">' +
        '<div class="tile">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="pinfo2"><div class="pname">' + p.title + '</div>' +
        '<div class="pricewrap"><span class="pprice">' + price + '</span></div></div></a>';
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var term = input.value.trim();
      if (term.length < 2) {
        defaults.hidden = false; results.hidden = true;
        return;
      }
      timer = setTimeout(async function () {
        try {
          var r2 = await fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8');
          var data = await r2.json();
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          defaults.hidden = true; results.hidden = false;
          grid.innerHTML = products.map(card).join('');
          empty.hidden = products.length > 0;
        } catch (err) { /* network hiccup: leave current state */ }
      }, 250);
    });
  


  /* ---------- product recommendations (You may also like) ---------- */
  document.querySelectorAll('[data-recommendations]').forEach(async function (sec) {
    try {
      var res = await fetch(sec.dataset.url);
      if (!res.ok) return;
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var freshGrid = doc.querySelector('.pgrid');
      var myGrid = sec.querySelector('.pgrid');
      if (freshGrid && myGrid && freshGrid.children.length > 0 && freshGrid.querySelector('.product')) {
        myGrid.innerHTML = freshGrid.innerHTML;
      }
    } catch (err) { /* keep collection fallback */ }
  });
})();

})();

  /* ---------- predictive search ---------- */
  (function () {
    var cfg = window.__search;
    if (!cfg) return;
    var input = q('[data-search-input]');
    if (!input) return;
    var defaults = q('[data-search-default]');
    var results = q('[data-search-results]');
    var grid = q('[data-search-results-grid]');
    var empty = q('[data-search-empty]');
    var timer;

    function card(p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
      var price = p.price ? ('$' + p.price) : '';
      return '<a class="product" href="' + p.url + '">' +
        '<div class="tile">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="pinfo2"><div class="pname">' + p.title + '</div>' +
        '<div class="pricewrap"><span class="pprice">' + price + '</span></div></div></a>';
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var term = input.value.trim();
      if (term.length < 2) {
        defaults.hidden = false; results.hidden = true;
        return;
      }
      timer = setTimeout(async function () {
        try {
          var r2 = await fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8');
          var data = await r2.json();
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          defaults.hidden = true; results.hidden = false;
          grid.innerHTML = products.map(card).join('');
          empty.hidden = products.length > 0;
        } catch (err) { /* network hiccup: leave current state */ }
      }, 250);
    });
  
  /* ---------- lightbox (product image zoom + size chart) ---------- */
  document.addEventListener('click', function (e) {
    var modal = q('[data-lightbox-modal]');
    if (!modal) return;
    var trigger = e.target.closest('[data-lightbox], [data-lightbox-src]');
    if (trigger) {
      var src = trigger.dataset.lightboxSrc;
      if (!src) { var im = trigger.querySelector('img'); src = im && im.src; }
      if (src) { modal.querySelector('[data-lightbox-img]').src = src; modal.hidden = false; document.body.style.overflow = 'hidden'; }
      return;
    }
    if (!modal.hidden && (e.target === modal || e.target.closest('[data-lightbox-close]'))) {
      modal.hidden = true; document.body.style.overflow = '';
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var m = q('[data-lightbox-modal]'); if (m && !m.hidden) { m.hidden = true; document.body.style.overflow = ''; } }
  });

})();


})();

/* instant navigation: prefetch product pages on hover/touch */
(function () {
  var seen = {};
  function prefetch(url) {
    if (seen[url]) return;
    seen[url] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    document.head.appendChild(l);
  }
  function handler(e) {
    var a = e.target.closest('a.product[href], .pgrid a[href*="/products/"]');
    if (a) prefetch(a.href.split('#')[0]);
  }
  document.addEventListener('mouseover', handler, { passive: true });
  document.addEventListener('touchstart', handler, { passive: true });
})();

/* ---------- lightbox color gallery: swipe / arrows through variant colors ---------- */
(function () {
  var modal = document.querySelector('[data-lightbox-modal]');
  if (!modal) return;
  var img = modal.querySelector('[data-lightbox-img]');
  if (!img) return;
  var urls = [], reps = [], idx = 0, active = false;

  function norm(u) { return (u || '').replace(/^https?:/, ''); }

  function buildGallery() {
    urls = []; reps = [];
    var vs = window.__productVariants || [];
    var map = window.__variantImages || {};
    var seen = {};
    vs.forEach(function (v) {
      var u = map[v.id];
      if (u && !seen[u]) { seen[u] = 1; urls.push(u); reps.push(v); }
    });
  }

  function mkBtn(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.innerHTML = dir < 0 ? '&#10094;' : '&#10095;';
    b.setAttribute('aria-label', dir < 0 ? 'Previous color' : 'Next color');
    b.style.cssText = 'position:absolute;top:50%;transform:translateY(-50%);' +
      (dir < 0 ? 'left:10px;' : 'right:10px;') +
      'width:48px;height:48px;border-radius:50%;border:0;cursor:pointer;' +
      'background:rgba(0,0,0,.45);color:#fff;font-size:20px;line-height:1;z-index:2;display:none';
    b.addEventListener('click', function (ev) { ev.stopPropagation(); nav(dir); });
    modal.appendChild(b);
    return b;
  }
  var prevB = mkBtn(-1), nextB = mkBtn(1);

  function colorOf(v) {
    var sw = document.querySelector('.sw[data-option-pos]');
    if (!sw || !v) return '';
    return v['option' + sw.dataset.optionPos] || '';
  }

  function show() {
    var on = active && urls.length > 1;
    prevB.style.display = nextB.style.display = on ? 'block' : 'none';
  }

  function nav(dir) {
    if (!active || urls.length < 2) return;
    idx = (idx + dir + urls.length) % urls.length;
    img.src = urls[idx];
    var c = colorOf(reps[idx]);
    if (c) {
      /* keep the product page in sync with the browsed color */
      var sw = document.querySelector('.sw[data-value="' + c.replace(/"/g, '\\"') + '"]');
      if (sw) sw.click();
    }
    show();
  }

  /* activate when opened from the main product image (not the size chart) */
  document.addEventListener('click', function (e) {
    if (modal.hidden) { active = false; show(); return; }
    var t = e.target.closest('[data-lightbox]');
    if (t && !t.dataset.lightboxSrc) {
      buildGallery();
      idx = 0;
      for (var i = 0; i < urls.length; i++) { if (norm(urls[i]) === norm(img.src)) { idx = i; break; } }
      active = true;
      show();
    } else if (e.target.closest('[data-lightbox-src]')) {
      active = false; show();
    }
  });

  /* swipe (one finger, horizontal wins over vertical) */
  var tx = null, ty = null;
  modal.addEventListener('touchstart', function (e) {
    if (e.touches.length === 1) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }
  }, { passive: true });
  modal.addEventListener('touchend', function (e) {
    if (tx === null) return;
    var dx = e.changedTouches[0].clientX - tx;
    var dy = e.changedTouches[0].clientY - ty;
    tx = ty = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) nav(dx < 0 ? 1 : -1);
  }, { passive: true });


/* ---------- lightbox color caption: shows the current color under the zoomed image ---------- */
(function () {
  var modal = document.querySelector('[data-lightbox-modal]');
  var mimg = modal && modal.querySelector('[data-lightbox-img]');
  if (!modal || !mimg) return;
  var cap = document.createElement('div');
  cap.style.cssText = 'display:none;position:absolute;left:50%;transform:translateX(-50%);z-index:2;' +
    'background:rgba(255,255,255,.92);color:#1c1c1c;font-weight:600;font-size:13px;padding:6px 14px;' +
    'border-radius:999px;box-shadow:0 2px 10px rgba(0,0,0,.3);pointer-events:none;white-space:nowrap';
  modal.appendChild(cap);
  var productMode = false;
  function place() {
    var on = document.querySelector('.sw.on');
    if (modal.hidden || !productMode || !on) { cap.style.display = 'none'; return; }
    cap.textContent = on.dataset.value;
    var r = mimg.getBoundingClientRect();
    cap.style.top = Math.min(r.bottom + 12, window.innerHeight - 52) + 'px';
    cap.style.display = 'block';
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-lightbox], [data-lightbox-src]');
    if (t) productMode = !t.dataset.lightboxSrc;
    setTimeout(place, 60);
  });
  mimg.addEventListener('load', place);
  new MutationObserver(place).observe(modal, { attributes: true, attributeFilter: ['hidden'] });
  new MutationObserver(place).observe(mimg, { attributes: true, attributeFilter: ['src'] });
  window.addEventListener('resize', place);
})();
  /* keyboard arrows on desktop */
  document.addEventListener('keydown', function (e) {
    if (modal.hidden) return;
    if (e.key === 'ArrowRight') nav(1);
    if (e.key === 'ArrowLeft') nav(-1);
  });
})();


/* ---------- cart upsell: two matching tees (radio box in the cart drawer) ---------- */
(function () {
  function refreshDrawer() {
    return fetch('/?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (data) {
      var html = data['cart-drawer'];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.cartpanel');
      var current = document.querySelector('.cartpanel');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      var t = fresh && fresh.querySelector('[data-cart-title]');
      var badge = document.querySelector('[data-cart-count]');
      if (t && badge) { var m = t.textContent.match(/\((\d+)\)/); if (m) badge.textContent = m[1]; }
    });
  }

  function upsellTotal(box) {
    var y = box.querySelector('[data-ups-your]');
    var t = box.querySelector('[data-ups-their]');
    if (!y || !t || !y.selectedOptions[0] || !t.selectedOptions[0]) return;
    var cents = (parseInt(y.selectedOptions[0].dataset.cents, 10) || 0) +
                (parseInt(t.selectedOptions[0].dataset.cents, 10) || 0);
    var out = box.querySelector('[data-ups-total-amount]');
    if (out) out.textContent = '$' + (cents / 100).toFixed(2);
  }

  document.addEventListener('change', function (e) {
    var r = e.target.closest('[data-ups-radio]');
    if (r) {
      var box = r.closest('[data-cart-upsell]');
      if (!box) return;
      var two = r.value === '2';
      box.querySelector('[data-ups-expand]').hidden = !two;
      box.querySelector('[data-ups-add]').hidden = !two;
      box.querySelector('[data-ups-total-price]').hidden = !two;
      if (two) upsellTotal(box); /* show the real total immediately using the current size selections */
      box.querySelectorAll('.upsopt').forEach(function (o) {
        o.classList.toggle('is-on', o.querySelector('input').checked);
      });
      return;
    }
    /* either size dropdown changed — recompute live so the number can never go stale */
    var sizeSel = e.target.closest('[data-ups-your],[data-ups-their]');
    if (sizeSel) {
      var box2 = sizeSel.closest('[data-cart-upsell]');
      if (box2) upsellTotal(box2);
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ups-add]');
    if (!btn || btn.classList.contains('busy')) return;
    var box = btn.closest('[data-cart-upsell]');
    if (!box) return;
    btn.classList.add('busy');
    var currentId = box.dataset.currentId;
    var yourId = box.querySelector('[data-ups-your]').value;
    var theirId = box.querySelector('[data-ups-their]').value;
    var chain;
    if (yourId === currentId) {
      chain = fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(theirId, 10), quantity: 1 }] })
      });
    } else {
      chain = fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: 1, quantity: 0 })
      }).then(function () {
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [
            { id: parseInt(yourId, 10), quantity: 1 },
            { id: parseInt(theirId, 10), quantity: 1 }
          ] })
        });
      });
    }
    chain.then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return refreshDrawer();
    }).catch(function () { btn.classList.remove('busy'); });
  });
})();

/* ---------- fixed header: tracks the announcement bar, then hides/reveals on scroll ----------
   .siteheader is position:fixed (Shopify wraps every section in its own auto-height div, which
   gives position:sticky zero room to actually stick past ~75px — confirmed by directly measuring
   both barelyhikingclub.com and slothhikingclub.com: neither "sticky" header stays pinned past
   the very top of the page). Fixed has no such limit, but it also ignores whatever used to sit
   above it in normal flow — the announcement bar — so `top` is set here every scroll frame
   (untransitioned, exact tracking) to sit the header just below the bar while it's still visible,
   sliding up to top:0 once the bar has fully scrolled away. The separate hide/reveal-on-scroll
   feature uses `transform` instead, with its own smooth transition, layered independently on top —
   `top` positions the header relative to the announcement bar, `transform` decides whether it's
   currently hidden, and the two never fight each other because they're different properties. */
(function () {
  var header = document.querySelector('.siteheader');
  var spacer = document.querySelector('[data-header-spacer]');
  var announce = document.querySelector('.announce');
  if (!header || !spacer) return;

  var headH = 0, annH = 0;
  function measure() {
    headH = header.offsetHeight;
    annH = announce ? announce.offsetHeight : 0;
    header.style.setProperty('--header-h', headH + 'px');
    spacer.style.setProperty('--header-h', headH + 'px');
  }
  measure();
  window.addEventListener('resize', measure);

  var lastY = window.scrollY, ticking = false;

  function onScroll() {
    var y = window.scrollY;
    var THRESHOLD = 80; /* px from top before hiding is allowed — keeps it visible near the top */

    /* instant, untransitioned: header sits right below whatever's left of the announcement bar */
    header.style.top = Math.max(0, annH - y) + 'px';

    /* smooth, transitioned: hide on scroll down past the threshold, reveal on any scroll up */
    if (y <= THRESHOLD) {
      header.classList.remove('headerhide');
    } else if (y > lastY) {
      header.classList.add('headerhide');
    } else if (y < lastY) {
      header.classList.remove('headerhide');
    }
    lastY = y;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
  }, { passive: true });
  onScroll();
})();


/* Shop Pay only — pull the Shop Pay button out of Shopify's bundled
   accelerated-checkout element, drop it alone into .dynbtn, and leave
   PayPal/Apple Pay/Google Pay unrendered. */
(function () {
  function mountShopPayOnly() {
    var source = document.querySelector('[data-wallet-source]');
    var target = document.querySelector('[data-dynbtn]');
    if (!source || !target) return;
    var shopPay = source.querySelector('[slot="button-ShopPay"]');
    if (!shopPay) return; // already moved this cycle, or not eligible for this visitor
    target.appendChild(shopPay);
  }
  mountShopPayOnly();
  var panel = document.querySelector('.cartpanel');
  if (panel) {
    new MutationObserver(mountShopPayOnly).observe(panel, { childList: true, subtree: true });
  }
})();

/* ---------- main product image: swipe left/right to change color ----------
   touchmove watches the gesture as it develops: once movement is clearly
   more horizontal than vertical (past LOCK_THRESHOLD), it locks the axis
   and calls preventDefault() on every touchmove for the rest of that touch,
   which stops iOS from also scrolling the page — same technique real
   swipeable carousels use. A gesture that turns out vertical is never
   locked, so normal page scrolling is completely unaffected. */
(function () {
  var wrap = document.querySelector('.pimage');
  if (!wrap) return;
  var LOCK_THRESHOLD = 10;
  var tx = null, ty = null, decided = false, locked = false;
  wrap.addEventListener('touchstart', function (e) {
    if (e.touches.length === 1) {
      tx = e.touches[0].clientX; ty = e.touches[0].clientY;
      decided = false; locked = false;
    }
  }, { passive: true });
  wrap.addEventListener('touchmove', function (e) {
    if (tx === null) return;
    var dx = e.touches[0].clientX - tx;
    var dy = e.touches[0].clientY - ty;
    if (!decided) {
      if (Math.abs(dx) < LOCK_THRESHOLD && Math.abs(dy) < LOCK_THRESHOLD) return;
      decided = true;
      locked = Math.abs(dx) > Math.abs(dy);
    }
    if (locked) e.preventDefault();
  }, { passive: false });
  wrap.addEventListener('touchend', function (e) {
    if (tx === null) return;
    var dx = e.changedTouches[0].clientX - tx;
    var dy = e.changedTouches[0].clientY - ty;
    var wasLocked = locked;
    tx = ty = null; decided = false; locked = false;
    if (!wasLocked) return;
    if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
    var swatches = Array.prototype.filter.call(document.querySelectorAll('.sw[data-option-pos]'), function (b) { return !b.classList.contains('unavail'); });
    if (swatches.length < 2) return;
    var curIdx = -1;
    swatches.forEach(function (b, i) { if (b.classList.contains('on')) curIdx = i; });
    if (curIdx === -1) return;
    var nextIdx = (curIdx + (dx < 0 ? 1 : -1) + swatches.length) % swatches.length;
    window.__imageSwipeDir = dx < 0 ? 'next' : 'prev';
    swatches[nextIdx].click();
  }, { passive: true });
})();

/* ---------- collection: pin a specific product first via ?first=<handle> ----------
   If the product is already rendered on the current page, just move it to the
   front. If it isn't (it's on a different pagination page), fetch that one
   product's data directly via Shopify's /products/<handle>.js endpoint --
   this works regardless of which page it normally falls on -- clone an
   existing tile as a template so the built tile automatically matches
   whatever sizes/colors are configured in the theme customizer, and prepend
   it to the grid. */
(function () {
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  var params = new URLSearchParams(window.location.search);
  var handle = params.get('first');
  if (!handle) return;
  var safeHandle = handle.replace(/"/g, '\\"');

  document.querySelectorAll('[data-pgrid]').forEach(function (grid) {
    var existing = grid.querySelector('a.product[data-handle="' + safeHandle + '"]');
    if (existing) {
      if (grid.firstElementChild !== existing) grid.insertBefore(existing, grid.firstElementChild);
      return;
    }
    var template = grid.querySelector('a.product');
    if (!template) return;
    fetch('/products/' + handle + '.js').then(function (r) {
      return r.ok ? r.json() : null;
    }).then(function (p) {
      if (!p) return;
      if (grid.querySelector('a.product[data-handle="' + safeHandle + '"]')) return;
      var tile = template.cloneNode(true);
      tile.href = p.url;
      tile.dataset.handle = p.handle;
      var img = tile.querySelector('img');
      if (img && p.featured_image) {
        img.src = p.featured_image + '&width=600';
        img.srcset = '';
        img.alt = p.title;
      }
      var name = tile.querySelector('.pname');
      if (name) name.textContent = p.title;
      var price = tile.querySelector('.pprice');
      if (price) price.textContent = money(p.price);
      var was = tile.querySelector('.pwas');
      var onSale = p.compare_at_price && p.compare_at_price > p.price;
      if (onSale) {
        if (!was) {
          was = document.createElement('span');
          was.className = 'pwas';
          var wrap = tile.querySelector('.pricewrap');
          if (wrap && price) wrap.insertBefore(was, price);
        }
        was.textContent = money(p.compare_at_price);
        was.style.display = '';
      } else if (was) {
        was.style.display = 'none';
      }
      grid.insertBefore(tile, grid.firstElementChild);
    });
  });
})();


/* ---------- sticky add to cart (mobile) ----------
   Shows a full-width bar fixed to the bottom of the screen, hidden by
   default via CSS. Two independent signals decide visibility: an
   IntersectionObserver watching the real .atc button (hide once any
   part of it is visible), and the site's shared overlay scrim (hide
   whenever the cart drawer, nav drawer, or search modal is open, so it
   never sits on top of / behind them). The bar only shows when NEITHER
   condition says to hide it. A MutationObserver mirrors the real
   button's text/disabled state onto the sticky one so they never drift
   out of sync. Clicking the sticky bar just clicks the real button, so
   it reuses the exact same add-to-cart flow with no duplicated logic. */
(function () {
  var sticky = document.querySelector('[data-sticky-atc]');
  var real = document.querySelector('.atc');
  if (!sticky || !real) return;

  function sync() {
    sticky.textContent = real.textContent;
    sticky.disabled = real.disabled;
  }
  sync();
  new MutationObserver(sync).observe(real, {
    characterData: true, childList: true, subtree: true,
    attributes: true, attributeFilter: ['disabled']
  });

  sticky.addEventListener('click', function () {
    if (!real.disabled) real.click();
  });

  var buttonVisible = false;
  var overlayOpen = false;
  function refresh() {
    sticky.classList.toggle('show', !buttonVisible && !overlayOpen);
  }

  new IntersectionObserver(function (entries) {
    buttonVisible = entries[0].isIntersecting;
    refresh();
  }, { threshold: 0 }).observe(real);

  var scrim = document.querySelector('[data-scrim]');
  if (scrim) {
    overlayOpen = scrim.classList.contains('show');
    new MutationObserver(function () {
      overlayOpen = scrim.classList.contains('show');
      refresh();
    }).observe(scrim, { attributes: true, attributeFilter: ['class'] });
  }
})();